module.exports = __webpack_public_path__ + "static/media/settlement.d96b7430.svg";